import { cn } from '../../lib/utils';

export const Separator = props => {
  const { className = '', ...rest } = props;
  return (
    <>
      <div className={cn('w-full h-1 border-b border-gray-900', className)} {...rest} />
    </>
  );
};
